import type { MenuConfig } from '~typings/menu'

import { permissionTree as permisos, RESOURCE_PRODUCCION_PG } from '@/auth/permissions/modules/produccionPg'
import {
    ROUTE_PPG_BANDEJA_ENTRADA_PROFORMAS,
    ROUTE_PPG_CONSULTA_ORDEN_PEDIDO,
} from '@/router/routes/producion-pg/nombres'
import { defineMenu } from '@/utils/menu'

const { informes } = permisos
export default defineMenu([
    {
        title: 'produccion_pg.subopciones.consulta_orden_pedido',
        resource: RESOURCE_PRODUCCION_PG,
        action: informes.consulta_orden_pedido,
        route: ROUTE_PPG_CONSULTA_ORDEN_PEDIDO,
    },
    {
        title: 'produccion_pg.subopciones.bandeja_entrada_proformas',
        resource: RESOURCE_PRODUCCION_PG,
        action: informes.bandeja_entrada_proformas,
        route: ROUTE_PPG_BANDEJA_ENTRADA_PROFORMAS,
    },
] as MenuConfig[])
